import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from './components/ErrorBoundary';
import MainLayout from './layouts/MainLayout';
import NotFound from './pages/NotFound';
import LoadingScreen from './components/ui/LoadingScreen';
import CookieConsent from './components/CookieConsent';
import ProtectedRoute from './components/admin/ProtectedRoute';

// Eagerly load critical components
import Landing from './pages/Landing';
import ResumeBuilder from './components/resume/ResumeBuilder';

// Lazy load feature pages
const Templates = React.lazy(() => import('./pages/Templates'));
const Features = React.lazy(() => import('./pages/Features'));
const Pricing = React.lazy(() => import('./pages/Pricing'));
const Blog = React.lazy(() => import('./pages/Blog'));

// Lazy load other pages
const AdminLogin = React.lazy(() => import('./pages/admin/Login'));
const AdminAnalytics = React.lazy(() => import('./pages/admin/Analytics'));
const About = React.lazy(() => import('./pages/About'));
const Contact = React.lazy(() => import('./pages/Contact'));
const FAQ = React.lazy(() => import('./pages/FAQ'));
const Tips = React.lazy(() => import('./pages/Tips'));
const Privacy = React.lazy(() => import('./pages/Privacy'));
const Terms = React.lazy(() => import('./pages/Terms'));
const Help = React.lazy(() => import('./pages/Help'));
const Sitemap = React.lazy(() => import('./pages/Sitemap'));

export default function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <CookieConsent />
        <Suspense fallback={<LoadingScreen show={true} />}>
          <Routes>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<Landing />} />
              <Route path="templates" element={<Templates />} />
              <Route path="features" element={<Features />} />
              <Route path="pricing" element={<Pricing />} />
              <Route path="blog" element={<Blog />} />
              <Route path="about" element={<About />} />
              <Route path="contact" element={<Contact />} />
              <Route path="faq" element={<FAQ />} />
              <Route path="tips" element={<Tips />} />
              <Route path="privacy" element={<Privacy />} />
              <Route path="terms" element={<Terms />} />
              <Route path="help" element={<Help />} />
              <Route path="sitemap" element={<Sitemap />} />
              <Route path="admin-login-xyz123" element={<AdminLogin />} />
              <Route 
                path="admin-stats-xyz123" 
                element={
                  <ProtectedRoute>
                    <AdminAnalytics />
                  </ProtectedRoute>
                } 
              />
            </Route>
            <Route path="*" element={<NotFound />} />
            <Route path="/resume" element={<ResumeBuilder />} />
            <Route path="/edit/:token" element={<ResumeBuilder />} />
          </Routes>
        </Suspense>
      </HelmetProvider>
    </ErrorBoundary>
  );
}